import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    heigth: '66px',
    margin: 0,
    marginBottom: '0.75rem',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  hero: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },

  title: {
    fontFamily: 'Sora',
    fontWeight: '400',
    fontSize: '34px',
    lineHeight: '42px',
    color: theme.palette.secondary.contrastText,
  },

  subtitle: {
    paddingTop: '2px',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '14.5px',
    lineHeight: '20px',
    color: theme.palette.secondary.contrastText,
    opacity: 0.6,
  },
}))

export { useStyles }
